import { makeStyles } from '@material-ui/core/styles';
import { PRIMARY, WHITE } from 'constants/colors';
export default makeStyles({
  paramButtonWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    '& Button': {
      maxWidth: 200
    }
  },
  listContainer: {
    backgroundColor: 'background.paper',
    position: 'relative',
    overflow: 'auto',
    minHeight: 125,
    maxHeight: 300
  },
  optionalButtonLayoutDialog: {
    display: 'flex',
    width: '100%',
    flexDirection: 'row-reverse',
    justifyContent: 'space-between'
  },
  chosenFormat: {
    backgroundColor: PRIMARY,
    color: WHITE
  },
  downloadOptionContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  }
});